var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJpg = function SvgJpg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jpg_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M15 25.5a1.5 1.5 0 0 1 1.5-1.5h21a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-21a1.5 1.5 0 0 1-1.5-1.5zm7.5 3.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M21 36h15l-5.25-9-3 6-2.25-3z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#6F14EE",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.29 12h1.606v4.113q-.002.586-.296 1.032a1.96 1.96 0 0 1-.802.69 2.7 2.7 0 0 1-1.175.247q-.577 0-1.055-.2a1.68 1.68 0 0 1-.761-.632q-.285-.434-.282-1.125h1.63q.008.225.075.38a.53.53 0 0 0 .194.235q.126.076.304.076a.55.55 0 0 0 .305-.079.5.5 0 0 0 .19-.234q.065-.157.068-.39zm2.378 6v-6h2.59q.668 0 1.17.264.5.264.778.74.279.479.279 1.117 0 .645-.287 1.116-.285.472-.8.727-.513.255-1.198.255h-1.547v-1.266h1.218q.288 0 .49-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .112-.442.83.83 0 0 0-.112-.44.7.7 0 0 0-.313-.28 1.1 1.1 0 0 0-.49-.1h-.574V18zm9.31-4.02a.8.8 0 0 0-.12-.272.839.839 0 0 0-.486-.328 1.3 1.3 0 0 0-.348-.044 1.2 1.2 0 0 0-.7.196q-.288.197-.44.566-.15.37-.15.89 0 .528.144.903t.428.574.706.2q.372 0 .618-.11a.8.8 0 0 0 .372-.307.87.87 0 0 0 .123-.469l.282.03h-1.372v-1.16h2.66v.832q0 .82-.348 1.403-.346.58-.955.89-.606.308-1.392.308-.875 0-1.538-.372a2.6 2.6 0 0 1-1.034-1.06q-.369-.69-.369-1.638 0-.744.226-1.319.228-.574.632-.97.404-.397.935-.6a3.1 3.1 0 0 1 1.137-.205q.532 0 .99.152.46.15.811.428.355.275.572.653t.263.83z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jpg_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgJpg;